import { render, staticRenderFns } from "./OrganisationTabs.vue?vue&type=template&id=4c6e963d&"
import script from "./OrganisationTabs.vue?vue&type=script&lang=js&"
export * from "./OrganisationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports